
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive",
      function () {
        return require("private-next-pages/archive/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive"])
      });
    }
  